import { render, staticRenderFns } from "./m-loader.vue?vue&type=template&id=1fd949c8&scoped=true&"
import script from "./m-loader.vue?vue&type=script&lang=js&"
export * from "./m-loader.vue?vue&type=script&lang=js&"
import style0 from "./m-loader.vue?vue&type=style&index=0&id=1fd949c8&lang=scss&scoped=true&"
import style1 from "./m-loader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd949c8",
  null
  
)

export default component.exports